import { removeLocationSpecificParamsForMapSearch } from '../common/locationUtils.js';


export const DEFAULT_PROJECT_SEARCH_URL = baseURL + 'donors/search.html';
export const DEFAULT_LOW_BARRIER_TO_ENTRY_SEARCH_URL = baseURL + 'common/essentials-list.json';
export const DEFAULT_SCHOOL_SEARCH_URL = baseURL + 'teachers/schoolSuggest.html';
export const DEFAULT_MIN_PERCENTAGE_TO_DISPLAY_ON_INITIAL_SEARCH = 0.05;
export const MIN_MARKERS_IN_VIEWPORT_FOR_SEARCH = 6; //a hard minimum on points shown for lower density areas
export const BOUNDS_RANGE_TO_RECENTER_TO_MARKER = 0.2;
export const MIN_MARKERS_IN_VIEWPORT_FOR_TOOLTIP = 1;
export const MAX_AUTO_SEARCH_COUNT = 50; // Max number of times a user can search via dragging around
export const MIN_ZOOM = 7;
export const NEED_LEVEL_CSS_SELECTORS = ['not-used', 'first', 'second', 'third', 'fourth'];
export const DEFAULT_SEARCH_RADIUS = 100; // Unit is miles
export const DEFAULT_SEARCH_RADIUS_IN_KM = 80.4672; // Unit is kilometers
export const DEFAULT_GEOPOINT_SPREAD_RADIUS = 0.001; // 0.001 is about 111m

// This defaults to the approximate location of the DonorsChoose HQ
const DEFAULT_STARTING_LAT = 40.755268096;
const DEFAULT_STARTING_LNG = -73.996688842;
const DEFAULT_STARTING_LAT_EST = DEFAULT_STARTING_LAT;
const DEFAULT_STARTING_LNG_EST = DEFAULT_STARTING_LNG;
const DEFAULT_STARTING_LAT_PST = 37.77493;
const DEFAULT_STARTING_LNG_PST = -122.419415;
const DEFAULT_STARTING_LAT_PHX = 33.448377;
const DEFAULT_STARTING_LNG_PHX = -112.074037;
const DEFAULT_STARTING_LAT_MST = 39.739236;
const DEFAULT_STARTING_LNG_MST = -104.990251;
const DEFAULT_STARTING_LAT_HST = 21.306944;
const DEFAULT_STARTING_LNG_HST = -157.858333;
const DEFAULT_STARTING_LAT_AKST = 61.218056;
const DEFAULT_STARTING_LNG_AKST = -149.900278;

// Default searches for States, because Google Places does not return a Lat/Lng for a State - Generally corresponds to the state capital
const DEFAULT_STATE_SEARCHES = {
    AL: { stateName: 'Alabama', defaultCityName: 'Montgomery', defaultLat: 32.3792, defaultLng: -86.3077 },
    AK: { stateName: 'Alaska', defaultCityName: 'Anchorage', defaultLat: 61.2181, defaultLng: -149.9003 },
    AZ: { stateName: 'Arizona', defaultCityName: 'Phoenix', defaultLat: 33.4484, defaultLng: -112.074 },
    AR: { stateName: 'Arkansas', defaultCityName: 'Little Rock', defaultLat: 34.7465, defaultLng: -92.2896 },
    CA: { stateName: 'California', defaultCityName: 'Sacramento', defaultLat: 38.5816, defaultLng: -121.4944 },
    CO: { stateName: 'Colorado', defaultCityName: 'Denver', defaultLat: 39.7392, defaultLng: -104.9903 },
    CT: { stateName: 'Connecticut', defaultCityName: 'Hartford', defaultLat: 41.7658, defaultLng: -72.6734 },
    DE: { stateName: 'Delaware', defaultCityName: 'Dover', defaultLat: 39.1582, defaultLng: -75.5244 },
    DC: { stateName: 'District of Columbia', defaultCityName: 'District of Columbia', defaultLat: 38.9072, defaultLng: -77.0369 },
    FL: { stateName: 'Florida', defaultCityName: 'Tallahassee', defaultLat: 30.4383, defaultLng: -84.2807 },
    GA: { stateName: 'Georgia', defaultCityName: 'Atlanta', defaultLat: 33.749, defaultLng: -84.388 },
    HI: { stateName: 'Hawaii', defaultCityName: 'Honolulu', defaultLat: 21.3069, defaultLng: -157.8583 },
    ID: { stateName: 'Idaho', defaultCityName: 'Boise', defaultLat: 43.615, defaultLng: -116.2023 },
    IL: { stateName: 'Illinois', defaultCityName: 'Springfield', defaultLat: 39.7817, defaultLng: -89.6501 },
    IN: { stateName: 'Indiana', defaultCityName: 'Indianapolis', defaultLat: 39.7684, defaultLng: -86.1581 },
    IA: { stateName: 'Iowa', defaultCityName: 'Des Moines', defaultLat: 41.5868, defaultLng: -93.625 },
    KS: { stateName: 'Kansas', defaultCityName: 'Topeka', defaultLat: 39.0473, defaultLng: -95.6752 },
    KY: { stateName: 'Kentucky', defaultCityName: 'Frankfort', defaultLat: 38.2009, defaultLng: -84.8733 },
    LA: { stateName: 'Louisiana', defaultCityName: 'Baton Rouge', defaultLat: 30.4515, defaultLng: -91.1871 },
    ME: { stateName: 'Maine', defaultCityName: 'Augusta', defaultLat: 44.3106, defaultLng: -69.7795 },
    MD: { stateName: 'Maryland', defaultCityName: 'Annapolis', defaultLat: 38.9784, defaultLng: -76.4922 },
    MA: { stateName: 'Massachusetts', defaultCityName: 'Boston', defaultLat: 42.3601, defaultLng: -71.0589 },
    MI: { stateName: 'Michigan', defaultCityName: 'Lansing', defaultLat: 42.7325, defaultLng: -84.5555 },
    MN: { stateName: 'Minnesota', defaultCityName: 'Saint Paul', defaultLat: 44.9537, defaultLng: -93.09 },
    MS: { stateName: 'Mississippi', defaultCityName: 'Jackson', defaultLat: 32.2988, defaultLng: -90.1848 },
    MO: { stateName: 'Missouri', defaultCityName: 'Jefferson City', defaultLat: 38.5767, defaultLng: -92.1735 },
    MT: { stateName: 'Montana', defaultCityName: 'Helena', defaultLat: 46.5891, defaultLng: -112.0391 },
    NE: { stateName: 'Nebraska', defaultCityName: 'Lincoln', defaultLat: 40.8136, defaultLng: -96.7026 },
    NV: { stateName: 'Nevada', defaultCityName: 'Carson City', defaultLat: 39.1638, defaultLng: -119.7674 },
    NH: { stateName: 'New Hampshire', defaultCityName: 'Concord', defaultLat: 43.2081, defaultLng: -71.5376 },
    NJ: { stateName: 'New Jersey', defaultCityName: 'Trenton', defaultLat: 40.2206, defaultLng: -74.7597 },
    NM: { stateName: 'New Mexico', defaultCityName: 'Santa Fe', defaultLat: 35.687, defaultLng: -105.9378 },
    NY: { stateName: 'New York', defaultCityName: 'New York', defaultLat: 40.7128, defaultLng: -74.006 },
    NC: { stateName: 'North Carolina', defaultCityName: 'Raleigh', defaultLat: 35.7796, defaultLng: -78.6382 },
    ND: { stateName: 'North Dakota', defaultCityName: 'Bismarck', defaultLat: 46.8083, defaultLng: -100.7837 },
    OH: { stateName: 'Ohio', defaultCityName: 'Columbus', defaultLat: 39.9612, defaultLng: -82.9988 },
    OK: { stateName: 'Oklahoma', defaultCityName: 'Oklahoma City', defaultLat: 35.4676, defaultLng: -97.5164 },
    OR: { stateName: 'Oregon', defaultCityName: 'Salem', defaultLat: 44.9429, defaultLng: -123.0351 },
    PA: { stateName: 'Pennsylvania', defaultCityName: 'Harrisburg', defaultLat: 40.2732, defaultLng: -76.8867 },
    RI: { stateName: 'Rhode Island', defaultCityName: 'Providence', defaultLat: 41.824, defaultLng: -71.4128 },
    SC: { stateName: 'South Carolina', defaultCityName: 'Columbia', defaultLat: 34.0007, defaultLng: -81.0348 },
    SD: { stateName: 'South Dakota', defaultCityName: 'Pierre', defaultLat: 44.3668, defaultLng: -100.3538 },
    TN: { stateName: 'Tennessee', defaultCityName: 'Nashville', defaultLat: 36.1627, defaultLng: -86.7816 },
    TX: { stateName: 'Texas', defaultCityName: 'Austin', defaultLat: 30.2672, defaultLng: -97.7431 },
    UT: { stateName: 'Utah', defaultCityName: 'Salt Lake City', defaultLat: 40.7608, defaultLng: -111.891 },
    VT: { stateName: 'Vermont', defaultCityName: 'Montpelier', defaultLat: 44.2601, defaultLng: -72.5754 },
    VA: { stateName: 'Virginia', defaultCityName: 'Richmond', defaultLat: 37.5407, defaultLng: -77.436 },
    WA: { stateName: 'Washington', defaultCityName: 'Olympia', defaultLat: 47.0379, defaultLng: -122.9007 },
    WV: { stateName: 'West Virginia', defaultCityName: 'Charleston', defaultLat: 38.3498, defaultLng: -81.6326 },
    WI: { stateName: 'Wisconsin', defaultCityName: 'Madison', defaultLat: 43.0722, defaultLng: -89.4008 },
    WY: { stateName: 'Wyoming', defaultCityName: 'Cheyenne', defaultLat: 41.14, defaultLng: -104.8202 },
};

const getDefaultStartingLatLng = function () {
    return {
        lat: DEFAULT_STARTING_LAT,
        lng: DEFAULT_STARTING_LNG,
    };
};

const getDefaultStartingLatLngBasedOnSystemTime = function () {
    const startingLatLng = getDefaultStartingLatLng();
    // Low-effort attempt to give a better default based on time zone
    if (Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions().timeZone) {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timeZone === 'America/New_York') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_EST;
            startingLatLng.lng = DEFAULT_STARTING_LNG_EST;
        } else if (timeZone === 'America/Los_Angeles') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_PST;
            startingLatLng.lng = DEFAULT_STARTING_LNG_PST;
        } else if (timeZone === 'America/Phoenix') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_PHX;
            startingLatLng.lng = DEFAULT_STARTING_LNG_PHX;
        } else if (timeZone === 'America/Denver') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_MST;
            startingLatLng.lng = DEFAULT_STARTING_LNG_MST;
        } else if (timeZone === 'Pacific/Honolulu') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_HST;
            startingLatLng.lng = DEFAULT_STARTING_LNG_HST;
        } else if (timeZone === 'America/Anchorage' || timeZone === 'America/Juneau') {
            startingLatLng.lat = DEFAULT_STARTING_LAT_AKST;
            startingLatLng.lng = DEFAULT_STARTING_LNG_AKST;
        }
    }
    return startingLatLng;
};

const getDefaultLatLngForStateCode = function (stateCode) {
    if (DEFAULT_STATE_SEARCHES[stateCode]) {
        const defaultStateInfo = DEFAULT_STATE_SEARCHES[stateCode];
        return {
            lat: defaultStateInfo.defaultLat,
            lng: defaultStateInfo.defaultLng,
            name: defaultStateInfo.stateName,
        };
    }
    return null;
};

function getNeedLevelForDisplay(freeReducedPriceLunch) {
    if (freeReducedPriceLunch >= 90) {
        return NEED_LEVEL_CSS_SELECTORS[4];
    } else if (freeReducedPriceLunch >= 76) {
        return NEED_LEVEL_CSS_SELECTORS[3];
    } else if (freeReducedPriceLunch >= 30) {
        return NEED_LEVEL_CSS_SELECTORS[2];
    }
    return NEED_LEVEL_CSS_SELECTORS[1];
}

function getNeedLevelForDisplayFromTheoryOfChangeId(theoryOfChangeId) {
    if (theoryOfChangeId == 1) {
        return NEED_LEVEL_CSS_SELECTORS[4];
    } else if (theoryOfChangeId == 2) {
        return NEED_LEVEL_CSS_SELECTORS[3];
    }
    return NEED_LEVEL_CSS_SELECTORS[1];
}

function roundCostToCompleteForDisplay(cost) {
    return Math.round(cost);
}

function sortByFrplAndSchoolNameAndCostToComplete(a, b) {
    // Sort in descending order for frpl first (in the event of multiple schools at the same lat/lng), then ascending school name, then ascending cost to complete
    const frplA = a.freeReducedPriceLunch || 0;
    const frplB = b.freeReducedPriceLunch || -1;
    const schoolNameA = a.schoolName;
    const schoolNameB = b.schoolName;
    const costA = a.costToComplete || 0;
    const costB = b.costToComplete || -1;
    if (frplA === frplB) {
        if (schoolNameA && schoolNameB && schoolNameA === schoolNameB) {
            return costA - costB;
        }
        return schoolNameA.localeCompare(schoolNameB);
    }
    return frplB - frplA;
}

function sortProjectsByCostToComplete(a, b) {
    const costA = a.costToComplete || 0;
    const costB = b.costToComplete || -1;
    // Sort in Ascending order
    return costA - costB;
}

function sortEssentialsByTopItemCost(a, b) {
    const costA = a.topItem ? a.topItem.price || 0 : 0;
    const costB = b.topItem ? b.topItem.price || -1 : -1;
    // Sort in Ascending order
    return costA - costB;
}

function calculateDistanceSquaredFromCenter (latitude, longitude, centerLat, centerLng) {
    const radius = 6371; // Earth in kilometers
    const pi = Math.PI / 180;

    // Haversine formula
    const a = 0.5 - Math.cos((latitude - centerLat) * pi) / 2 +
        Math.cos(centerLat * pi) *
        Math.cos(latitude * pi) *
        (1 - Math.cos((longitude - centerLng) * pi)) / 2;

    return 2 * radius * Math.asin(Math.sqrt(a));
}

function getSearchCircle(resultsBoundingRadius, map) {
    return new google.maps.Circle({
        strokeColor: "#9F887A",
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: "#B8A495",
        fillOpacity: 0,
        map: map,
        center: map.center,
        radius: (resultsBoundingRadius * 1000) + 100, // Resulting Bounding Radius converted to meters, and a 100m buffer
    });
}

function getNewSearchParamsFromMapCenter (map, startingLat, startingLng) {
    const center = map.getCenter();
    const newSearchLat = center.lat();
    let newSearchLng = center.lng();
    // Normalize Longitude, if needed
    if (newSearchLng < -180 || newSearchLng > 180) {
        newSearchLng = (newSearchLng % 360 + 540) % 360 - 180;
    }
    const newSearchParams = {
        centerLat: newSearchLat ? newSearchLat : startingLat,
        centerLng: newSearchLng ? newSearchLng : startingLng,
        concise: true,
        map: true,
        radius: DEFAULT_SEARCH_RADIUS,
    };
    return newSearchParams;
}

/**
 * Mutate searchParams with whatever additional parameters are required by resultFilters.
 *
 * @param searchParams Query string parameters for a search URL, but in JS object form. The thing we build/return throughout this file.
 * @param resultFilters An object representing the state of the map-search result-filtering checkboxes.
 */
export const applyResultFilters = (searchParams, resultFilters) => {
    (resultFilters.equityFocus || resultFilters.lowCostOnly || resultFilters.matchOffers) ? $("#content").addClass("hide-others") : $("#content").removeClass("hide-others");

    if (resultFilters.lowCostOnly) {
        searchParams.costToComplete = 2;
    }
    if (resultFilters.equityFocus) {
        searchParams.equityFocus = true;
    }
    if (resultFilters.matchOffers) {
        searchParams.matchingId = -1;
    }
};
export const getInitialResultFiltersFromUrl = (url) => {
    const params = window.getURLParams(url);

    // Note that everything coming out of getURLParams will be stringly-typed
    return {
        lowCostOnly: params.costToComplete === '2',
        equityFocus: params.equityFocus === 'true',
        matchOffers: params.matchingId === '-1',
    };
};

export const getStartingDisplayOnlyClassroomEssentialsFromUrl = (url) => {
    const params = window.getURLParams(url);

    return params.classroomEssentialsOnly === 'true';
};

function getNewSearchParamsFromLocationSearchUrl (locationSearchUrl) {
    const newSearchParams = getURLParams(locationSearchUrl);
    if ((!newSearchParams.centerLat || !newSearchParams.centerLng) && newSearchParams.state) {
        const searchParamsForState = getDefaultLatLngForStateCode(newSearchParams.state);
        if (searchParamsForState) {
            newSearchParams.centerLat = searchParamsForState.lat;
            newSearchParams.centerLng = searchParamsForState.lng;
        }
    }
    const newLocationSearchParams = removeLocationSpecificParamsForMapSearch(newSearchParams);
    if (!newSearchParams.radius) {
        newSearchParams.radius = DEFAULT_SEARCH_RADIUS;
    }
    if (!newSearchParams.map) {
        newSearchParams.map = true;
    }
    if (!newSearchParams.concise) {
        newSearchParams.concise = true;
    }
    return { newSearchParams, newLocationSearchParams };
}

// Not used, but has been suggested and implemented multiple times, so I'm just leaving it here.
function getPointsAroundCenter(center, numPoints, radius) {
    if (numPoints == 1) {
        return [center];
    }
    const points = [];
    for (const index in [...Array(numPoints).keys()]) {
        const latOffset = Math.cos(2 * index * Math.PI / numPoints);
        const lngOffset = Math.sin(2 * index * Math.PI / numPoints);
        //console.log(index, numPoints, 2 * index * Math.PI / numPoints, latOffset, lngOffset);
        points.push({
            lat: center.lat + (radius * latOffset),
            lng: center.lng + (radius * lngOffset),
        });
        //console.log(center.lat, center.lng + " -> " + points[index].lat, points[index].lng);
    }
    return points;
}

export const Helpers = {
    getDefaultLatLngForStateCode: getDefaultLatLngForStateCode,
    getDefaultStartingLatLngBasedOnSystemTime: getDefaultStartingLatLngBasedOnSystemTime,
    getNeedLevelForDisplay: getNeedLevelForDisplay,
    getNeedLevelForDisplayFromTheoryOfChangeId: getNeedLevelForDisplayFromTheoryOfChangeId,
    roundCostToCompleteForDisplay: roundCostToCompleteForDisplay,
    sortByFrplAndSchoolNameAndCostToComplete: sortByFrplAndSchoolNameAndCostToComplete,
    sortProjectsByCostToComplete: sortProjectsByCostToComplete,
    sortEssentialsByTopItemCost: sortEssentialsByTopItemCost,
    calculateDistanceSquaredFromCenter: calculateDistanceSquaredFromCenter,
    getSearchCircle: getSearchCircle,
    getNewSearchParamsFromLocationSearchUrl: getNewSearchParamsFromLocationSearchUrl,
    getNewSearchParamsFromMapCenter: getNewSearchParamsFromMapCenter,
    getPointsAroundCenter: getPointsAroundCenter,
};
